import { render, staticRenderFns } from "./AnnualPlanView.vue?vue&type=template&id=25561785&scoped=true&"
import script from "./AnnualPlanView.vue?vue&type=script&lang=js&"
export * from "./AnnualPlanView.vue?vue&type=script&lang=js&"
import style0 from "./AnnualPlanView.vue?vue&type=style&index=0&id=25561785&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25561785",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VRow})
